import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="py-4 text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 transition hover:text-primary-700">
            <i className="ri-home-5-line" aria-hidden="true" />
            首页
          </Link>
        </li>
        {items.map((c, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />
            {c.to ? (
              <Link to={c.to} className="transition hover:text-primary-700">{c.label}</Link>
            ) : (
              <span className="text-foreground-800" aria-current="page">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}